import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { observer } from 'mobx-react-lite';
import { UpgradeLicenseFormProps } from 'components/Forms';
export const PremiumSupport: FC<UpgradeLicenseFormProps> = observer(({ alowPlanSelection }) => {
  const {
    upgradeLicenseStore: { getUpgradeLicenseInfo, upgradelicenseplan },
    notificationStore: { openNotification },
  } = useStore();

  const getUpgradeLicense = useQuery('getUpgradeLicense', () => getUpgradeLicenseInfo(), {
    onError: () => openNotification('error', `Can't get upgrade license info`),
  });

  const classes = useStyles();
  useAppPreloader(getUpgradeLicense.isLoading);

  return (
    <>
      <Grid container className={classes.featuredetail}>
        {upgradelicenseplan.map(
          (feature, index) =>
            feature.name === 'Add-On' &&
            feature.list.map((values, index) => (
              <Grid key={index} className={classes.featuredetailicon} item xs={6} md={4}>
                <CheckIcon className={classes.featureicons} /> <span>{values}</span>
              </Grid>
            ))
        )}
      </Grid>
    </>
  );
});
